<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 170 120"
    :width="width"
    :height="width"
  >
    <g :fill="iconColor">
      <path d="M 0 120 L 40 60 L 0 0 L 30 0 L 70 60 L 30 120" />
      <path d="M 136.666667 85 L 123.333333 65 L 170 65 L 170 85" />
      <path d="M 116.666667 55 L 103.333333 35 L 170 35 L 170 55" />
    </g>

    <g :fill="iconColor2">
      <path
        d="M 40 120 L 80 60 L 40 0 L 70 0 L 150 120 L 120 120 L 95 82.5 L 70 120"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "HaskellIcon",
  props: {
    width: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: "currentColor"
    },
    iconColor2: {
      type: String,
      default: "#48866a"
    }
  }
};
</script>

<style scoped></style>
